interface BackgroundTextProps {
  text: string;
}

const BackgroundText = ({ text }: BackgroundTextProps) => {
  return (
    <div className="text-center my-10 relative">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-10">
        <h2 className="text-[80px] sm:text-[160px] md:text-[200px] lg:text-[250px] font-medium text-[#D9D9D9] tracking-wider">
          {text.toUpperCase()}
        </h2>
      </div>
      <h2 className="text-4xl md:text-5xl font-medium text-white py-0 sm:py-20">{text}</h2>
    </div>
  );
};

export default BackgroundText;